import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Anchor = styled(Link)`
  text-decoration: none;
  color: white;
`;

export {
  Anchor,
};
